"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentExportWindow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const app_1 = require("../../../app");
const payment_1 = require("../../../model/payment");
const auth_1 = require("../../../utils/auth");
const helpers_1 = require("../../../utils/helpers");
const rest_provider_1 = require("../../../utils/rest_provider");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const PaymentExportRequestProvider = new rest_provider_1.RestProvider({
    name: "payments_exports",
    create: "POST|/payments/export",
    delete: "",
    index: "",
    new: "",
    show: "",
    update: ""
});
exports.PaymentExportWindow = {
    request: {},
    active: false,
    isProcessing: false,
    show() {
        exports.PaymentExportWindow.active = true;
        exports.PaymentExportWindow.isProcessing = false;
        this.request = {};
        mithril_1.default.redraw();
    },
    renderForm(form) {
        form.obj.from = form.obj.from || (0, moment_timezone_1.default)().tz(app_1.App.BOOKING_TIMEZONE).date(1).format("YYYY-MM-DD");
        form.obj.to = form.obj.to || (0, moment_timezone_1.default)(form.obj.from).add(1, "month").format("YYYY-MM-DD");
        return (0, mithril_1.default)("div", form.selectField("Type de paiements", "type", payment_1.PAYMENT_TYPES), (0, mithril_1.default)("label.label", "Periode du:"), (0, mithril_1.default)("p", { style: "max-width: 15rem;" }, (0, helpers_1.inputWithIcon)("fa-calendar", {
            type: "date",
            value: (0, moment_timezone_1.default)(form.obj.from, "YYYY-MM-DD").format("YYYY-MM-DD"),
            onchange: (evt) => { form.obj.from = evt.target.value; }
        })), (0, mithril_1.default)("label.label", "au:"), (0, mithril_1.default)("p", { style: "max-width: 15rem;" }, (0, helpers_1.inputWithIcon)("fa-calendar", {
            type: "date",
            value: (0, moment_timezone_1.default)(form.obj.to, "YYYY-MM-DD").format("YYYY-MM-DD"),
            onchange: (evt) => { form.obj.to = evt.target.value; }
        })));
    },
    validateAllFields() {
        let request = exports.PaymentExportWindow.request;
        return request.from != null && request.from != "" &&
            request.to != null && request.to != "" &&
            request.type != null && request.type != "";
    },
    renderCancelButton() {
        return (0, mithril_1.default)("button", {
            class: "button is-danger",
            onclick: (evt) => {
                evt.preventDefault();
                exports.PaymentExportWindow.active = false;
            }
        }, (0, helpers_1.iconSpan)("fa-times"), (0, mithril_1.default)("span", " Annuler"));
    },
    view(_node) {
        if (exports.PaymentExportWindow.active) {
            return (0, form_for_1.formFor)(exports.PaymentExportWindow.request, PaymentExportRequestProvider, (form) => {
                return (0, modal_1.modalCard)({
                    title: "Exporter les paiements",
                    content: exports.PaymentExportWindow.renderForm(form),
                    foot: (0, mithril_1.default)(".is-pulled-right.is-primary", (0, mithril_1.default)("button.button", {
                        onclick: () => { window.open(app_1.App.serviceURL(`/payments/export?__at__=${auth_1.Auth.uriEncodedToken()}&from=${form.obj.from}&to=${form.obj.to}&type=${form.obj.type}`)); },
                        disabled: !exports.PaymentExportWindow.validateAllFields(),
                    }, "Exporter"), this.renderCancelButton()),
                    isActive: exports.PaymentExportWindow.active,
                    onClose: () => { exports.PaymentExportWindow.active = false; }
                });
            });
        }
        return undefined;
    }
};
